// TODO: Podriamos añadir al config del back alarmColor como parámetro
// en lugar de alertColor en la config de la obs y si fuera necesario agregar

import { I_AlarmAudioConfigResponse, I_AlarmConfigResponse } from "../api/alarm-config.response";
import { C_ObservationAlarmData } from "../../display/items/observation/domain/observation-alarm-data.model";
import { E_AlarmSoundType } from "../../../enums/alarm-type.enum";

// la configuración del sonido
export class C_AlarmConfig {
  enabled?: boolean;
  endAfter?: number;
  startBefore?: number;
  recording?: C_AlarmItem;
  beacon?: C_AlarmItem;
  openDoor?: C_AlarmItem;
  priority: number = 7;
  color?: string = "white";
  audioConfig?: C_AlarmSoundConfig;
  constructor(data?: I_AlarmConfigResponse) {
    if (!data) return;
    this.initialize(data);
  }

  initialize(data: I_AlarmConfigResponse) {
    if (data.enabled) this.enabled = data.enabled;
    if (data.endAfter) this.endAfter = data.endAfter;
    if (data.startBefore) this.startBefore = data.startBefore;
    if (data.beacon) this.beacon = new C_AlarmItem(data.beacon);
    if (data.openDoor) this.openDoor = new C_AlarmItem(data.openDoor);
    if (data.priority) this.priority = data.priority;
    if (data.color) this.color = data.color;
    if (data.recording) this.recording = data.recording;
    if (data.audioConfig) this.audioConfig = new C_AlarmSoundConfig(data.audioConfig);
  }

  toInterface(): I_AlarmConfigResponse {
    return {
      enabled: !!this.enabled,
      endAfter: this.endAfter,
      startBefore: this.startBefore,
      beacon: this.beacon?.toInterface(),
      openDoor: this.openDoor?.toInterface(),
      priority: this.priority,
      color: this.color,
      audioConfig: this.audioConfig?.toInterface(),
      recording: this.recording,
    }
  }

}

export class C_AlarmItem {
  enabled?: boolean;
  endAfter?: number;
  startBefore?: number;
  color?: string;
  severity?: string;
  beaconColor?: number;

  constructor(data?: I_AlarmConfigResponse) {
    if (!data) return;
    this.initialize(data);
  }

  initialize(data: I_AlarmConfigResponse) {
    if (data?.enabled) this.enabled = data.enabled
    if (data?.endAfter) this.endAfter = data.endAfter
    if (data?.startBefore) this.startBefore = data.startBefore
    if (data?.color) this.color = data.color
    if (data?.severity) this.severity = data.severity
    if (data?.beaconColor) this.beaconColor = data.beaconColor
  }

  toInterface(): I_AlarmConfigResponse {
    return {
      enabled: !!this.enabled,
      endAfter: this.endAfter,
      startBefore: this.startBefore,
      color: this.color,
      severity: this.severity,
      beaconColor: this.beaconColor,
      audioConfig: undefined,
      beacon: undefined,
      openDoor: undefined,
      priority: undefined,
      recording: undefined,
    }
  }
}

export class C_AlarmSoundConfig {
  type: E_AlarmSoundType = E_AlarmSoundType.OFF;
  path?: string;
  endAfter?: number;

  constructor(data?: I_AlarmAudioConfigResponse) {
    if (!data) return;
    this.initialize(data);
  }

  initialize(data: I_AlarmAudioConfigResponse) {
    if (data?.type) this.type = data.type;
    if (data?.path) this.path = data.path;
    if (data?.endAfter) this.endAfter = data.endAfter;
  }

  toInterface(): I_AlarmAudioConfigResponse {
    return {
      type: this.type,
      endAfter: this.endAfter,
      path: this.path,
    }
  }
}

export class C_AudioPlayBackItem {
  duration: number = 3000; // Expires(continuous) // OnStart(endAfter)
  audioToPlay?: string;
  patientId?: string;
  displayId?: string;
  bed?: string;
  type?: E_AlarmSoundType;
  name?: string; // Name
  value?: string;
  priority: number = 10
  time?: Date;
  expires: number = 3
  endAfter: number = 3000
  constructor(
    json: C_ObservationAlarmData,
    patientId: string,
    display: string,
    bed: string
  ) {
    if (patientId) this.patientId = patientId;
    if (bed) this.bed = bed;
    if (display) this.displayId = display;
    if (json.alarmConfig?.audioConfig?.type) this.type = json.alarmConfig?.audioConfig?.type;
    if (json.name) this.name = json.name; // Name
    if (json.alarmConfig?.audioConfig?.path != null && json.alarmConfig?.audioConfig?.path.startsWith("http")) {
      this.audioToPlay = json.alarmConfig?.audioConfig?.path
    } else {
      switch (this.name) {
        case "RedAlarm":
          this.audioToPlay = "assets/audio/red.mp3"
          break;
        case "YellowAlarm":
          this.audioToPlay = "assets/audio/yellow.mp3"
          break;
        case "ShortYellowAlarm":
          this.audioToPlay = "assets/audio/shortYellow.mp3"
          break;
        case "HardInop":
          this.audioToPlay = "assets/audio/blue.mp3"
          break;
        case "SoftInop":
          this.audioToPlay = "assets/audio/blue.mp3"
          break;
        case "AdvisoryAlert":
          this.audioToPlay = "assets/audio/blue.mp3"
          break;
        default: this.audioToPlay = "assets/audio/blue.mp3"

      }
    }
    if (json.value) this.value = json.value;
    if (json.priorityLevel) this.priority = json.priorityLevel;
    if (json.time) this.time = new Date(json.time);
    if (json.expires) this.expires = json.expires;
    if (json.alarmConfig?.audioConfig?.endAfter) this.endAfter = json.alarmConfig?.audioConfig?.endAfter;
    if (this.type) {
      const now = Date.now().valueOf();
      switch (this.type) {
        case E_AlarmSoundType.CONTINUOUS:
          const expiredAt = this.time ? (this.time.valueOf() + (this.expires * 1000)) : 0;
          this.duration = expiredAt ? expiredAt - now : 0;
          break;
        case E_AlarmSoundType.ONSTART:
          const expiredAtOnStart = this.time ? (this.time.valueOf() + (this.endAfter)) : 0;
          this.duration = (expiredAtOnStart && (expiredAtOnStart - now) < 0 ? 0 : (expiredAtOnStart - now)) || 0;
          break;
      }
    }

  }
  isExpired(): boolean {
    if (this.time != null && this.expires != null) {
      const now = Date.now().valueOf();
      // si es continua exiperes es la expiracion de la observacion si no es la expiracion del sonido
      const expiredAt = this.type == E_AlarmSoundType.CONTINUOUS ? this.time.valueOf() + (this.expires * 1000) : this.time.valueOf() + (this.endAfter);
      return now > expiredAt;
    }
    return false;
  }
}